import Logger from "common/Logger"; const LOGGER = new Logger("analytics.ts");import GoogleAnalytics from "./googleAnalytics"

class AnalyticsSingleton {
    private static instance: GoogleAnalytics | null = null
    private static initialized = false

    public static getInstance(): GoogleAnalytics {
        if (!this.instance) this.instance = new GoogleAnalytics()

        return this.instance
    }

    public static init(measurementId: string, debug = false, retryCount = 0): void {
        if (this.initialized) return

        const ga = this.getInstance()
        if (typeof window !== "undefined" && measurementId) {
            ga.init(measurementId, debug, () => {
                this.initialized = false
                if (retryCount < 1) {
                    LOGGER.warn("GA init failed, retrying once...", {})
                    setTimeout(() => AnalyticsSingleton.init(measurementId, debug, retryCount + 1), 3000)
                } else {
                    LOGGER.error("GA init failed after retry, giving up", {})
                }
            })

            this.initialized = true
        }
    }
}

const analytics = AnalyticsSingleton.getInstance()

// Initialize automatically if env variable is present
if (process.env.SITELINE_GTAG && typeof window !== "undefined") AnalyticsSingleton.init(process.env.SITELINE_GTAG, true)

export default analytics
